import posthog from "posthog-js";
import type { ProductAnalyticsEvents, ProductEventName } from "@types";

export interface RecordedProductEvent {
  name: ProductEventName;
  props: Record<string, unknown>;
  at: number;
}

declare global {
  interface Window {
    __hsProductEvents?: RecordedProductEvent[];
  }
}

const BUFFER_LIMIT = 100;

// PostHog is never initialised in development (root.tsx bails on MODE ===
// "development"), so the in-page buffer is the only way an e2e running against
// the dev stack can prove a call site actually fired.
function recordInPage(name: ProductEventName, props: Record<string, unknown>) {
  if (typeof window === "undefined") return;
  const buffer = (window.__hsProductEvents ??= []);
  buffer.push({ name, props, at: Date.now() });
  if (buffer.length > BUFFER_LIMIT) buffer.shift();
}

export function captureProductEvent<K extends ProductEventName>(
  name: K,
  props: ProductAnalyticsEvents[K],
) {
  recordInPage(name, props as Record<string, unknown>);
  if (!posthog.__loaded) return;
  posthog.capture(name, props as Record<string, unknown>);
}
